import React from 'react';

import { Col, Container, Row } from 'reactstrap';
import styled from 'styled-components';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import TextAccordion from 'components/ModularBlocks/BasicTextBlock/TextAccordion';
import RichTextField from 'components/RichTextField/RichTextField';
import TitleHeader from 'components/TitleHeader';

import { BasicTextBlockI } from 'interfaces/content-stack/modular-blocks/basicTextBlock';

const TextBlockContainer = styled(Container)`
  ${(props) =>
    props.$noPadding &&
    `
    padding: 0;
    
    &.container {
      padding: 0;
    }
  
    .row {
      margin: 0;
      
      > * {
        padding: 0;
      }
    }
  `}
`;

export interface BasicTextBlockProps {
  data: BasicTextBlockI;
  className: string;
}

function BasicTextBlock({ data, className }: BasicTextBlockProps) {
  const { header, body, accordion, blockReference } = data;

  return (
    <ContentContainer>
      <TextBlockContainer className={className} $noPadding>
        <Row>
          <Col xs={12}>
            {Array.isArray(blockReference) &&
              blockReference.length > 0 &&
              blockReference.map((ref, index) => (
                <div key={index}>
                  {ref.accordion && <TextAccordion body={ref.body} header={ref.header} />}
                  {!ref.accordion && (
                    <div>
                      {ref.header && <TitleHeader>{ref.header}</TitleHeader>}
                      {ref.body && <RichTextField richText={ref.body} />}
                    </div>
                  )}
                </div>
              ))}
            {accordion && <TextAccordion body={body} header={header} />}
            {!accordion && (
              <div>
                {header && <TitleHeader>{header}</TitleHeader>}
                {body && <RichTextField richText={body} />}
              </div>
            )}
          </Col>
        </Row>
      </TextBlockContainer>
    </ContentContainer>
  );
}

export default BasicTextBlock;
